import { useMemo } from 'react'

import { useAuthentication } from '@pages/Authentication/context'
import { AuthLoading } from '@components/shared/AuthLoading'
import { getSessionStorage } from '@utils/states/sessionStorage'
import { isTokenExpired } from '@utils/functions/isTokenExpired'

import type { PrivateRouteProps } from './types'

export const PrivateRoute = ({ element }: PrivateRouteProps) => {
  const { isAuthenticated, getLoginRedirectUrl, setIsAuthenticated, refreshToken } = useAuthentication()

  const isTokenValid = useMemo(() => {
    const token = getSessionStorage<string>('@SMARTOPS_ACCESSTOKEN')

    if (!token) {
      getLoginRedirectUrl()
      setIsAuthenticated(false)
      return false
    }

    if (isTokenExpired(token)) {
      refreshToken()
      return false
    }

    setIsAuthenticated(true)

    return true
  }, [isAuthenticated, getLoginRedirectUrl, refreshToken])

  return <>{isTokenValid ? element : <AuthLoading />}</>
}
